import { AdvancedSelect as Select, Alert, Input, Layouts, Loader } from 'components';
import s from './styles.module.scss';
import { useState, useRef, useEffect, useCallback } from 'react';
import { head } from 'helpers';
import * as api from 'api';
import { useNavigate } from 'react-router-dom';

export default function Main() {
  const [loadingStatus, setLoadingStatus] = useState('Loading...');
  const [loading, setLoading] = useState(false);
  const [oldFeeds, setOldFeeds] = useState([]);
  const [feeds, setFeeds] = useState([]);

  const navigate = useNavigate();
  const processing = useRef(false);

  const updateOldFeeds = (field, value, index) => {
    const updated = [...oldFeeds];
    updated[index][field] = value;
    setOldFeeds(updated);
  };

  const updateNewFeeds = (field, value, index) => {
    const updated = [...feeds];
    updated[index][field] = value;
    setFeeds(updated);
  };

  const removeOldFeed = index => {
    setOldFeeds(prev => prev.filter((_, i) => i !== index));
  };

  const removeNewFeed = index => {
    setFeeds(prev => prev.filter((_, i) => i !== index));
  };

  const fetchFeeds = useCallback(async () => {
    if (processing.current) return;
    processing.current = true;
    setLoading(true);

    const res = await api.publicApi.socialFeed.fetchFeeds({});
    if (res.code === 200) {
      const validFeeds = Array.isArray(res.payload?.feeds) ? res.payload.feeds : [];
      setOldFeeds(validFeeds);
    } else {
      Alert.error(res.message);
    }

    setLoading(false);
    processing.current = false;
  }, []);

  useEffect(() => {
    fetchFeeds();
  }, [fetchFeeds]);

  const saveHandler = async () => {
    if (processing.current) return;

    const allFeeds = [...oldFeeds, ...feeds];
    if (allFeeds.length === 0) return Alert.warn('All fields are required for each social feed item.');

    processing.current = true;
    Alert.success('Saving Social Feeds...');
    setLoading(true);

    const res = await api.publicApi.socialFeed.updateFeeds({
      oldFeeds,
      feeds,
    });

    if (res.code === 201) {
      Alert.success(res.message);
      // navigate(-1)
    } else {
      Alert.error(res.message);
    }

    setLoading(false);
    processing.current = false;
  };

  useEffect(() => {
    head({ title: 'Social Feed | Admin' });
  }, []);

  return (
    <div className={s.main}>
      <div className={s.socialFeedOuter}>
        <Layouts.Classic title="Social Feed">
          <div className={s.headerBottom}>
            <div className={s.addFeed} onClick={saveHandler}>
              <span className="material-icons-outlined">save</span> Save
            </div>
          </div>
        </Layouts.Classic>

        {!loading && (
          <div className={`${s.content} innerScrollX`}>
            <div className={s.feeds}>
              <div className={s.label}>Social Feed</div>

              {Array.isArray(oldFeeds) &&
                oldFeeds.map((item, i) => (
                  <FeedItem
                    key={i}
                    index={i}
                    item={item}
                    onChange={updateOldFeeds}
                    onRemove={removeOldFeed}
                  />
                ))}

              {Array.isArray(feeds) &&
                feeds.map((item, i) => (
                  <FeedItem
                    key={`new-${i}`}
                    index={i}
                    item={item}
                    onChange={(field, value, idx) => updateNewFeeds(field, value, idx)}
                    onRemove={removeNewFeed}
                  />
                ))}
            </div>

            <div className={s.addMore}>
              <div
                onClick={() =>
                  setFeeds(prev => {
                    if (!Array.isArray(prev)) return [{ platform: '', title: '', link: '' }];
                    return [...prev, { platform: '', title: '', link: '' }];
                  })
                }
              >
                Add Feed
                <span className="material-icons-outlined">add_circle_outline</span>
              </div>
            </div>
          </div>
        )}

        {loading && (
          <div className={s.loader}>
            <Loader
              message={loadingStatus}
              color="var(--c-primary)"
              colorText="var(--c-primary)"
            />
          </div>
        )}
      </div>
    </div>
  );
}

const FeedItem = ({ index, item = {}, onChange, onRemove }) => {
  const platforms = [
    { label: 'Select', value: 'Select'},
    { label: 'Facebook', value: 'Facebook' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'YouTube', value: 'YouTube' },
    { label: 'WhatsApp', value: 'WhatsApp' },
  ];

  const selectedPlatform = platforms.find(p => p.value === item.platform) || null;

  return (
    <div className={s.testimony}>
      <div className={s.title}>
        <span>Feed {index + 1}</span>
        <span onClick={() => onRemove(index)}>
          Remove <span className="material-icons-outlined">cancel</span>
        </span>
      </div>
<Select
  label="Platform"
  iconLeft="public"
  list={platforms}
  fieldName="label"
  defaultField={item.platform}
  listFieldHandler={selected => {
    onChange('platform', selected.value, index);
  }}
/>
        
      <Input.Classic
        type="text"
        label="Title"
        iconLeft="title"
        placeholder="Enter feed title"
        value={item.title || ''}
        onChange={e => onChange('title', e.target.value, index)}
      />

      <Input.Classic
        type="text"
        label="Link"
        iconLeft="link"
        placeholder="Enter link"
        value={item.link || ''}
        onChange={e => onChange('link', e.target.value, index)}
      />
    </div>
  );
};
